"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMenuItemSelect = exports.ApMenuItemSelectInternal = void 0;
/* tslint:disable */
var ApIcon_1 = require("../ApIcon");
var theme_1 = require("../../utils/theme");
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var context_1 = require("./context");
var styles_1 = require("./styles");
exports.ApMenuItemSelectInternal = react_1.forwardRef(function (props, ref) {
    var onClick = props.onClick, children = props.children, className = props.className, textClassName = props.textClassName, disabled = props.disabled, isOpen = props.isOpen, disableHover = props.disableHover, disableCloseOnClick = props.disableCloseOnClick, selected = props.selected, rest = __rest(props, ["onClick", "children", "className", "textClassName", "disabled", "isOpen", "disableHover", "disableCloseOnClick", "selected"]);
    var closeAll = react_1.useContext(context_1.default).closeAll;
    var handleClick = react_1.useCallback(function (event) {
        if (onClick) {
            onClick(event);
        }
        if (!disableCloseOnClick) {
            closeAll();
        }
    }, [onClick, closeAll, disableCloseOnClick]);
    return (React.createElement(styles_1.MenuItem, __assign({}, rest, { ref: ref, isOpen: isOpen, disabled: disabled, disableHover: disableHover, className: className, onClick: handleClick }),
        React.createElement(styles_1.IconWrapper, null, selected && React.createElement(ApIcon_1.ApIcon, { iconSize: 16, iconName: 'check', iconColor: theme_1.colors.grey700 })),
        React.createElement(styles_1.MenuItemText, { className: textClassName }, children)));
});
exports.ApMenuItemSelect = react_1.memo(exports.ApMenuItemSelectInternal);
//# sourceMappingURL=ApMenuItemSelect.js.map